import { eachDayOfInterval, add, sub, format } from 'date-fns/esm';
import * as actionTypes from '../actions/actionTypes';
import undoable, { includeAction, excludeAction, combineFilters, distinctState } from 'redux-undo'
import {Map} from 'immutable';
import _ from 'lodash'

const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

const dates = eachDayOfInterval({
    start: sub(new Date(), {days: 10}),
    end: add(new Date(), {days: 10})
})
const focus = dates.reduce((o, key) => Object.assign(o, {[format(key, 'LLL d Y')]: []}), {});

const initialState = {
    data: Map({
        items: {},
        sections: {},
        pages: {},
        tags: {},
        alerts: {},
        schedules: {},
    }),
    alerts: [],
    loadedPages: [],
    loadedDates: [],
    focus: focus,
    error: null,
    taskQueue: [],
    taskIndex: null,
    extLoaded: false,
    deferred: {},
    deferredLoaded: false
};

const today = format(new Date(), 'LLL d Y')
const reducer = ( state = initialState, action ) => {
    let updatedData = {...state.data.toJS()}

    switch ( action.type ) {
        case actionTypes.TIME_TRAVEL:
            return updateObject( state, {data: Map(action.data)})
        case actionTypes.UPDATE_QUEUE:
            if(action.queue){
                return updateObject( state, {taskQueue: action.queue, taskIndex: !state.taskIndex ? 0 : state.taskIndex})
            } else if (action.task){
                let updatedQueue = state.taskQueue
                updatedQueue.push(action.task)
                return updateObject( state, {taskQueue: updatedQueue, taskIndex: !state.taskIndex ? 0 : state.taskIndex})
            }
            
        case actionTypes.UPDATE_QUEUE_INDEX:
            return updateObject( state, {taskIndex: action.index})

        case actionTypes.INCREASE_QUEUE_INDEX:
            return updateObject( state, {taskIndex: state.taskIndex + 1})
        case actionTypes.CLEAR_QUEUE_INDEX:
            return updateObject( state, {taskIndex: 0})

        case actionTypes.ERROR:
            console.log('[db.js reducers]', action.error)
            if(action.data) {
                return updateObject(state, {error: action.error, data: Map(action.data)})
            } else {
                return updateObject(state, {error: action.error})
            }
        case actionTypes.GET_DATA:
            return updateObject(state, {
                data: Map(_.cloneDeep(action.data)), 
                loadedPages: _.union(state.loadedPages, action.loadedPages),
                loadedDates: _.union(state.loadedDates, action.loadedDates),
                deferred: action.deferred   
            })
        case actionTypes.LOAD_DEFERRED:
            return updateObject(state, { deferredLoaded: action.deferredLoaded })
        case actionTypes.UPDATE_DATA:
            return updateObject(state, {
                data: Map(Object.freeze(action.data)), 
                loadedPages: _.union(state.loadedPages, action.loadedPages),
                loadedDates: _.union(state.loadedDates, action.loadedDates),
                deferred: action.deferred
            })
        case actionTypes.UPDATE_ALERTS:
            return updateObject(state, { alerts: action.alerts })
        case actionTypes.COMMIT_DATA:
            return updateObject(state, {data: Map({...action.data})})

        case actionTypes.GET_FOCUS:
            return updateObject(state, {focus: Map(action.data)})
        case actionTypes.CREATE_FOCUS:
            return updateObject(state, {data: Map(action.data)})
        case actionTypes.UPDATE_FOCUS:
            return updateObject(state, {data: Map(action.data)})

        default:
            return updateObject(state)
    }
};

// export default reducer;

/////////////////
// REDUX UNDO //
///////////////
function undoableHandler(action,state) {
    if([actionTypes.GET_DATA, actionTypes.UPDATE_DATA, actionTypes.CREATE_FOCUS, actionTypes.UPDATE_FOCUS].includes(action.type)){
        return action.type
    }
}

export default undoable(reducer, {
    filter: combineFilters(undoableHandler),
    debug: false,
    syncFilter: true,
})






